// src/containers/pages/caseManagement/components/MoveConfirmDialog.tsx

import React from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from 'components/mui';

interface MoveConfirmDialogProps {
  open: boolean;
  selectedCount: number;
  sourceCaseTitle: string;
  destCaseTitle: string;
  onConfirm: () => void;
  onCancel: () => void;
}

function MoveConfirmDialog({
  open,
  selectedCount,
  sourceCaseTitle,
  destCaseTitle,
  onConfirm,
  onCancel,
}: MoveConfirmDialogProps) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Move Activities</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Move {selectedCount} activity(ies) from case "{sourceCaseTitle}" to
          case "{destCaseTitle}"?
        </DialogContentText>
        <DialogContentText sx={{ mt: 1, fontSize: '0.85rem' }}>
          This will update the case assignment, group, project, deliverable,
          and activity for each selected entry. This action cannot be undone
          automatically.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="outlined">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          Move {selectedCount} Activities
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default MoveConfirmDialog;
